import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import moment from "moment";
import JobService from "../../../Services/JobService";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import { ChangeStatus } from "../../../Components";
import { useLocation } from "react-router-dom";

import { revenuecostService } from "../../../Services/revenuecostService";

import { MdEdit, MdSearch, MdVisibility } from "react-icons/md";
import ReactPaginate from "react-paginate";
import CheckAccess from "../../../Function/CheckAccess";
let currentPage1 = 1;

export const DeletedJobList = () => {
  const history = useHistory();

  const [jobItem, setJobItem] = useState([]);
  const [startDate, setStarDate] = useState();
  const [endDate, setEndData] = useState();
  const [searchField, setSearchField] = useState();
  const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);

  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  const getStyle = {
    valueContainer: (provided) => ({
      ...provided,
      height: "calc(2.15rem + 2px)",
      overflowY: "visible",
    }),
    control: (provider) => ({
      ...provider,
      width: "200px",
      boxShadow: "0 0 0 0px #f46a6a",
    }),
    placeholder: (provider) => ({
      ...provider,
      color: "#a0b0ca",
    }),
  };

  useEffect(() => {
    getJobList();
    signInIntuit();
  }, [searchField, startDate, endDate, currentPage]);

  const signInIntuit = () => {
    var win;
    var parameters = "location=1,width=800,height=650";
    parameters +=
      ",left=" +
      (window.innerWidth - 800) / 2 +
      ",top=" +
      (window.innerHeight - 650) / 2;

    revenuecostService.qbookAuth().then((result) => {
      if (!result.status) {
        localStorage.setItem("redirectUri", window.location.href);
        window.location.href = result.uri;
      }
    });
  };

  const getJobList = () => {
    let param = {
      page: currentPage,
      limit: pagination.limit,
      is_deleted: true,
    };
    if (startDate) {
      param["start_date"] = getTimeStamp(startDate);
    }
    if (endDate) {
      param["end_date"] = getTimeStamp(endDate);
    }
    if (searchField) {
      param["search"] = searchField;
    }
    setLoader(true);
    JobService.getJobapi(param).then((result) => {
      if (result.status === true) {
        setJobItem(result.data);
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  const getTimeStamp = (date) => {
    let SingleTimestamp = new Date(date);
    return SingleTimestamp.getTime();
  };

  function resetHandler() {
    setStarDate("");
    setEndData("");
    setSearchField("");
  }

  const getSumValue = (array) => {
    let plusVolume = array
      .map((item) => item.booking.total_volume_CBM)
      .reduce((prev, cur) => prev + cur, 0);

    let plusWeight = array
      .map((item) => item.booking.total_weight_KG)
      .reduce((prev, cur) => prev + cur, 0);

    let plusPackage = array
      .map((item) => item.booking.no_of_pkgs)
      .reduce((prev, cur) => prev + cur, 0);

    return {
      totalvolume: plusVolume.toFixed(2),
      totalweight: plusWeight,
      totalpkg: plusPackage,
    };
  };

  const onModalSubmit = () => {
    let payload = {
      job_token: isModalOpen.job_token,
      status: isModalOpen.is_job_open === "OPEN" ? "CLOSE" : "OPEN",
    };
    JobService.setJobOpenStatus(payload).then((result) => {
      setIsModalOpen(false);
      if (result.status) {
        toast.success(result.message);
        getJobList();
      } else {
        toast.error(result.message);
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex mb-3 justify-content-start align-items-end table_filter ">
              <div className="col-3">
                <label>Search Token</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search.."
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>
              <div className="col-3">
                <label>Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setStarDate(e.target.value)}
                  value={startDate}
                />
              </div>
              <div className="col-3">
                <label>End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setEndData(e.target.value)}
                  value={endDate}
                />
              </div>

              <div className="mx-3">
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => resetHandler()}
                >
                  Reset
                </button>
              </div>
              <div className="mx-3">
                {(CheckAccess(415,"add") ||
                  user_type === "SUPERADMIN") && (
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light"
                    onClick={() => history.push("/add-job-card")}
                  >
                    Add +
                  </button>
                )}
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th rowSpan="2">S no.</th>
                    <th rowSpan="2"> Job No.</th>
                    <th rowSpan="2"> Shipping Mode</th>
                    <th rowSpan="2">
                      Customer <br />
                      Name
                    </th>
                    <th rowSpan="2">Job Date</th>
                    <th rowSpan="2">Destination</th>
                    <th rowSpan="2">
                      Payment <br /> Status
                    </th>
                    <th rowSpan="2">
                      {" "}
                      Job <br /> Status
                    </th>

                    <th rowSpan="2" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {jobItem &&
                    jobItem.length > 0 &&
                    jobItem.map((val, key) => {
                      if (Array.isArray(val.quote_request_items)) {
                        var calculateVal = getSumValue(val.quote_request_items);
                      }
                      return (
                        <tr key={key}>
                          <td className="text-body fw-bold">
                            {(pagination.page - 1) * pagination.limit +
                              (key + 1)}
                          </td>
                          {/* <td scope="row">{key + 1}</td> */}
                          <td>{val.job_token}</td>
                          <td>
                            <span className="badge rounded-pill font-size-12 pointer bg-success">
                              {(val && val.shipment_details.shipment_mode) ||
                                "NA"}
                            </span>
                          </td>

                          <td>{val.customer_details.name || "NA"}</td>
                          <td>{moment(val.created_at).format("DD-MM-YYYY")}</td>
                          <td>
                            {val.shipment_details.destination +
                              (val.shipment_details?.destination_country
                                ? " ," +
                                  val.shipment_details.destination_country
                                : "")}
                          </td>
                          <td>
                            {" "}
                            <span className="badge rounded-pill font-size-12 pointer bg-success">
                              {(val.payment_information &&
                                val.payment_information.payment_status) ||
                                "NA"}
                            </span>{" "}
                          </td>
                          <td>
                            {" "}
                            <span
                              className="badge rounded-pill font-size-12 pointer bg-success"
                              onClick={() => setIsModalOpen(val)}
                            >
                              {val.is_job_open || "NA"}
                            </span>{" "}
                          </td>

                          <td>
                            <MdVisibility
                              className="pointer"
                              onClick={() =>
                                history.push(
                                  "/view-job-cart?id=" + val._id,
                                  val
                                )
                              }
                              color="#0323fe"
                              size="25px"
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              {jobItem && jobItem.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {jobItem &&
                jobItem.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}

              <Loader isShow={loader} />
            </div>
          </div>
        </div>
      </div>
      {Boolean(isModalOpen) && (
        <ChangeStatus
          isOpen={Boolean(isModalOpen)}
          title="Job Status"
          message={`Are you sure want to ${
            isModalOpen.is_job_open === "OPEN" ? "CLOSE" : "OPEN"
          }`}
          onSubmitEvent={() => onModalSubmit()}
          handleClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
